import {useStores} from "../Hooks";

const GetInfoFromUrlHook = () => {
    const {generalStore, projectStore, procedureStore} = useStores();

    function getInfoFromUrl() {

        let parentFolder = 'root';
        let projectId;
        const db = generalStore.workspace
        const {currentProject} = projectStore;
        const {currentProcedure} = procedureStore;
        if (currentProject && currentProject.ProjectIdentifier) {
            projectId = currentProject.ProjectIdentifier;
            const url = window.location.href;
            const parts = url.split("/procedures/");
            if (parts.length > 1) {
                parentFolder = parts[1].split("/")[0];
            }
        } else if (currentProcedure && currentProcedure.ProjectRef) {
            projectId = currentProcedure.ProjectRef;

        }
        return {projectId, parentFolder, db}
    }

    return getInfoFromUrl

}

export default GetInfoFromUrlHook;